import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Info-index-1992f2b74e1d2a245-1'),
    routerUrl: '/Info',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Info')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Info-index-1992f2b74e1d2a245-2'),
        routerUrl: '/InfoForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./InfoForm')),
      },
      {
        needLogin: true,
        resourceName: i18n.t('Info-index-1992f2b74e1d2a245-3'),
        routerUrl: '/CreditForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./CreditForm')),
      },
      //$MORE$
    ],
  },
];
